import { createContext, useContext } from 'react'
import { InstallationStatusModel } from '../types'

interface InstallationStatusContextValue {
  statusMap: Map<number, InstallationStatusModel>
  isLoading: boolean
}

const InstallationStatusContext = createContext<InstallationStatusContextValue>({
  statusMap: new Map(),
  isLoading: false,
})

export const useInstallationStatusContext = (): InstallationStatusContextValue => useContext(InstallationStatusContext)

export default InstallationStatusContext
